<template>
  <form class="form form-loyalty-terminate mb-0" @submit.prevent="postForm">

    <slide-x-left-transition :duration="400" :delay="200">
      <div class="form-group" v-show="show">
        <label>Data wypowiedzenia</label>
        <div class="input-wrapper">
          <input type="date"
                 v-model="form.date"
                 placeholder="Data wypowiedzenia">
        </div>
        <p class="error" v-if="errors.date" v-text="errors.date[0]"></p>
      </div>
    </slide-x-left-transition>

    <slide-x-left-transition :duration="500" :delay="300">
      <div class="form-group" v-show="show">
        <label>Powód</label>
        <div class="select-wrapper">
          <span v-if="form.subject_id === null" class="select-placeholder">Wybierz powód</span>
          <select v-model="form.reason" required>
            <option value="null" selected disabled>Wybierz powód</option>
            <option v-for="item in reasons" :value="item.label">
              {{ item.label.length > 50 ? item.label.substring(0, 50) + "..." : item.label }}
            </option>
          </select>
        </div>
        <p class="error" v-if="errors.reason">{{ errors.reason[0] }}</p>
      </div>
    </slide-x-left-transition>

    <!--preview full reason-->
    <div class="form-loyalty-terminate-reason-preview mt-10 mb-10" v-if="form.reason">
      <p>Wybrany powód:</p>
      <p><i>{{ form.reason }}</i></p>
    </div>

    <slide-x-left-transition :duration="600" :delay="400">
      <div class="form-group" v-show="show && form.reason == 'Inny'">
        <label>Twoja treść</label>
        <div class="input-wrapper">
          <textarea v-model="form.message" rows="10" placeholder="Wpisz treść wypowiedzenia"/>
        </div>
        <p class="error" v-if="errors.message">{{ errors.message[0] }}</p>
      </div>
    </slide-x-left-transition>

    <!--submit-->
    <ion-button mode="ios"
                expand="block"
                type="submit"
                :disabled="form.reason === null || form.date === null">
      <span v-if="loading"><span class="loader"></span></span>
      <span v-else>Wypowiedz umowę</span>
    </ion-button>
  </form>
</template>

<script>
  import { mapState } from 'vuex'
  import api from '@/services/Api'
  import goTo from '@/mixins/goto'

  function getDefaultFormData() {
    return {
      reason: null,
      message: null,
      date: null
    }
  }

  export default {
    name: 'FormLoyaltyTerminate',
    mixins: [goTo],
    data() {
      return {
        show: false,
        form: getDefaultFormData()
      }
    },
    computed: {
      ...mapState({
        errors: state => state.loyalty.errors,
        loading: state => state.loyalty.loading,
        loyaltyContractBrand: state => state.clients.single ? state.clients.single.loyalty_program.brand : null,
        loyaltyContractUuid: state => state.clients.single ? state.clients.single.loyalty_program.contract_uuid : null,
      }),
      reasons(){
        return [
          {
            label: 'Rażące działanie Uczestnika na szkodę Organizatora',
          },
          {
            label: 'Niemożność wykonywania przez Uczestnika obowiązków wynikających z Regulaminu, a w' +
                ' szczególności z powodu zaprzestania lub zawieszenia sprzedaży produktów Organizatora w' +
                ' Lokalu, spowodowanej utratą wymaganych prawem zezwoleń na sprzedaż napojów alkoholowych',
          },
          {
            label: 'Zaprzestanie wykonywania zadań określonych w § 4 Regulaminu, w tym w szczególności' +
                ' naruszenia zasady priorytetu wolumenu Organizatora lub nieprzyznania piwu marki' +
                ' „'+ this.loyaltyContractBrand +'” pozycji lidera w Lokalu',
          },
          {
            label: 'Brak zgody Uczestnika na związanie nowym, zmienionym regulaminem Programu, w przypadku' +
                ' wprowadzenia przez Organizatora zmian do niniejszego Regulaminu',
          },
          {
            label: 'Inny', // special value! (check template)
          },
        ]
      }
    },
    mounted(){
      this.show = true
    },
    methods: {
      postForm() {
        // prepare data
        let data = {
          'date' : this.form.date
        }
        if(this.form.reason == 'Inny'){
          data = {...data, 'reason': this.form.message } // re-bind reason field (requested)
        }else{
          data = {...data, 'reason': this.form.reason }
        }

        let payload = {'uuid': this.loyaltyContractUuid, 'data' : data}
        this.$store.dispatch('loyalty/LOYALTY_CONTRACT_TERMINATE_REQUEST', payload).then(resp => {
          this.goBack();
        })
      }
    }
  }
</script>